export default "__VITE_ASSET__adc6311d__"